function reconcileAuthEligibility(PatientId, AuthId, AuthNo, SectionName) {
    reconcileEligibility(PatientId, AuthId, AuthNo, 0, 0, SectionName);
}
function reconcileComplaintEligibility(PatientId, ComplaintId, ComplaintNo, SectionName) {
    reconcileEligibility(PatientId, 0, 0, ComplaintId, ComplaintNo, SectionName);
}
function reconcileEligibility(PatientId, AuthId, AuthNo, ComplaintId, ComplaintNo, SectionName) {
    var patientId = "";
    var memberId = ToValue($("#Session_LoggedInUserID").val(), null) !== null ? $("#Session_LoggedInUserID").val() : memberidval;
    if ($(".InAuthPage").is(":visible")) {
        var PI = UmPatient_AuthInfo("", "");
        patientId = PI.PatientId;
        var authDivId = PI.AuthDivId;
        var authId = PI.AuthId;
        var authNo = PI.AuthNo;
        var authContentId = "#AuthInit_2_1 .Content #Grid_AuthPatientEligibility";
        var btnAccId = "#AuthDiv_" + PI.AuthNoId;
        $(authContentId, authDivId).html('');
        $(authContentId, authDivId).load(baseURL + '/EligibilityReconciliation/MemberEligibilityReconciliation', function () {
            var AccId = authDivId + " #Accordion_Group_2 #AuthInit_2_1";
            $(".Content", AccId).show();
            $(AccId + " #BtnAct").removeClass("ActionExpand").addClass("ActionCollapse");
            $(AccId + " #Grid_EligibilityReconciliation").show();
            $(AccId + " #Grid_EligibilityReconciliation").html("Loading....");
            var AccordId = AccId.substring(1, AccId.length);
            var authPatientEligibility = AccordId + " #Grid_EligibilityReconciliation";
            LoadMemberEligibilityFullView(authPatientEligibility, '', memberId, '', '', '', '', '', patientId, 0, 0, true, function () {
                $(AccId + " #Grid_EligibilityReconciliation .memberEligibility").removeAttr("onclick");
                $(AccId + " .divAuthType").hide(0);
                $(AccId + " .ReconcileEligibilityButtons").hide();
                $(AccId + " #reconcileEligibility").text(' Reconciling eligibility');
                $(AccId + " #spnReconcileEligibility").show();
                $(AccId + " #spnReconcileEligibility").text(' - Record of eligibilities available for this member' + "'s " + 'authorization.');
                if ($(btnAccId + " #divAccessedOtherStaffMessage").is(":visible")){
                    $(AccId + " #Grid_EligibilityReconciliation .memberEligibility").prop('disabled', true);
                }
            });
            $(document).off('click', $.fn.getCntrlId(authPatientEligibility, '.memberEligibility')).on('click', $.fn.getCntrlId(authPatientEligibility, '.memberEligibility'), function () {
                $('#' + authPatientEligibility + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').removeClass('active');
                $(this).addClass('active');
                $('#hdnReconcileAuthLobBenId').val($(authDivId + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("lobbenid"));
                $('#hdnReconcileAuthMemBenfPlanId').val($(authDivId + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("membenfplanid"));
                $(AccId + ' .ReconcileEligibilityButtons').show();
                $(AccId + ' #reconcile_update_btn').removeAttr('onclick');
                $(AccId + ' #reconcile_update_btn').attr('onclick', 'validateAuthEligibilityPrerequisites("' + patientId + '","' + authId + '", "' + authNo + '", "' + $('#hdnReconcileAuthLobBenId').val() + '", "' + $('#hdnReconcileAuthMemBenfPlanId').val() + '")');
            });
        });
    }
    else if ($(".InComplaintPage").is(":visible")) {
        var CI = AgData.complaintInfo();
        patientId = CI.patientId;
        var complaintId = CI.complaintId;
        var complaintNo = CI.complaintNo;
        var complaintDivId = CI.complaintDivId;
        var complaintContentId = "#divComplaint_EligibilityDetail";
        $(complaintContentId, complaintDivId).html('');
        $(complaintContentId, complaintDivId).load(baseURL + '/EligibilityReconciliation/MemberEligibilityReconciliation', function () {
            $(complaintDivId + " #Grid_EligibilityReconciliation").show();
            $(complaintDivId + " #Grid_EligibilityReconciliation").html("Loading....");
            var complaintPatientEligibility = complaintDivId.slice(1) + " #Grid_EligibilityReconciliation";
            LoadMemberEligibilityFullView(complaintPatientEligibility, '', memberId, '', '', '', '', '', patientId, 0, 0, true, function () {
                $(complaintDivId + " #Grid_EligibilityReconciliation .memberEligibility").removeAttr("onclick");
                $(complaintDivId + " .divShowHideForReconcileEligibility").hide();
                $(complaintDivId + " .ReconcileEligibilityButtons").hide();
                if (CI.complaintLockStatus > 0) {
                    $(complaintDivId + " #Grid_EligibilityReconciliation .memberEligibility").prop('disabled', true);
                }
            });
            $(document).off('click', $.fn.getCntrlId(complaintPatientEligibility, '.memberEligibility')).on('click', $.fn.getCntrlId(complaintPatientEligibility, '.memberEligibility'), function () {
                $('#' + complaintPatientEligibility + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').removeClass('active');
                $(this).addClass('active');
                $('#hdnReconcileComplaintLobBenId').val($(complaintDivId + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("lobbenid"));
                $('#hdnReconcileComplaintMemBenfPlanId').val($(complaintDivId + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("membenfplanid"));
                $(complaintDivId + ' .ReconcileEligibilityButtons').show();
                $(complaintDivId + ' #reconcile_update_btn').removeAttr('onclick');
                $(complaintDivId + ' #reconcile_update_btn').attr('onclick', 'validateComplaintEligibilityPrerequisites("' + patientId + '","' + complaintId + '", "' + complaintNo + '", "' + $('#hdnReconcileComplaintLobBenId').val() + '", "' + $('#hdnReconcileComplaintMemBenfPlanId').val() + '")');
            });
        });
    }
    else {
        patientId = PatientId;
        var title = " Eligibility Reconciliation";
        var description = "";
        if (SectionName === 'OPEN_AUTHORIZATIONS' || SectionName === 'OPEN_AUTHORIZATIONS_MAL' || SectionName === 'ER_AUTHORIZATIONS') {
            description = "Record of member eligibilities. Choose a tile to update the eligibility linked to this authorization.";
        }
        else {
            description = "Record of member eligibilities. Choose a tile to update the eligibility linked to this complaint.";
        }
        $('#popUpDialog1').CMNPopupUM({
            pvUrl: baseURL + "/EligibilityReconciliation/MemberEligibilityReconciliation",
            onLoad: function () {
                var patientEligibility = "Grid_EligibilityReconciliation";
                LoadMemberEligibilityFullView(patientEligibility, '', memberId, '', '', '', '', '', patientId, 0, 0, true, function () {
                    $('#popUpDialog1 .ReconcileEligibilityButtons').hide();
                    $('#popUpDialog1 #divReconcileEligibilityInfoMessage').show();
                    if (SectionName === 'OPEN_AUTHORIZATIONS' || SectionName === 'OPEN_AUTHORIZATIONS_MAL' || SectionName === 'ER_AUTHORIZATIONS') {
                        $('#popUpDialog1 #lblReconcileEligibilityInfoMessage').text('Authorization due date could be affected by a new eligibility selection.');
                    }
                    else {
                        $('#popUpDialog1 #lblReconcileEligibilityInfoMessage').text('Çomplaint due date could be affected by a new eligibility selection.');
                    }
                    A11yModal.trapFocusInModal('popUpDialog1');
                });
                $(document).off('click', $.fn.getCntrlId(patientEligibility, '.memberEligibility')).on('click', $.fn.getCntrlId(patientEligibility, '.memberEligibility'), function () {
                    $('#' + patientEligibility + ' #MemEligMain_FullView #divFullViewData .memberEligibility.active').removeClass('active');
                    $(this).addClass('active');
                    $('#hdnReconcileLobBenId').val($(' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("lobbenid"));
                    $('#hdnReconcileMemBenfPlanId').val($(' #MemEligMain_FullView #divFullViewData .memberEligibility.active').data("membenfplanid"));
                    $('#popUpDialog1 .ReconcileEligibilityButtons').show();
                    $('#popUpDialog1 #reconcile_update_btn').removeAttr('onclick');
                    if (SectionName === 'OPEN_AUTHORIZATIONS' || SectionName === 'OPEN_AUTHORIZATIONS_MAL' || SectionName === 'ER_AUTHORIZATIONS') {
                        $('#popUpDialog1 #reconcile_update_btn').attr('onclick', 'validateAuthEligibilityPrerequisites("' + patientId + '","' + AuthId + '", "' + AuthNo + '", "' + $('#hdnReconcileLobBenId').val() + '", "' + $('#hdnReconcileMemBenfPlanId').val() + '","' + SectionName + '")');
                    }
                    else {
                        $('#popUpDialog1 #reconcile_update_btn').attr('onclick', 'validateComplaintEligibilityPrerequisites("' + patientId + '","' + ComplaintId + '", "' + ComplaintNo + '", "' + $('#hdnReconcileLobBenId').val() + '", "' + $('#hdnReconcileMemBenfPlanId').val() + '","' + SectionName + '" )');
                    }
                    A11yModal.trapFocusInModal('popUpDialog1');
                });
            },
            onClose: onERPopUpClose,
            popUpHeader: title,
            popUpDescription: description,
            popLevel: 0,
            closeButton: "#btnERClose",
            modalWidth: MODAL_WIDTH.LARGE
        });
    }
}
function onERPopUpClose() {
    $('#popUpDialog1').hide();
    $("body").css({ "overflow": "visible" });
    $('#btnERClose').trigger('click');
    $('#popUpDialog1').html('');
    closePopupLeanOverlay();
}
function validateAuthEligibilityPrerequisites(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName) {
    loader(1);
    $.ajax({
        type: "GET",
        url: baseURL + "/Authorization/ValidateEligibilityForAuth?authId=" + authId + "&lobBenId=" + lobBenId,
        dataType: "json",
        success: function (authEligibilityType) {
            loader(0);
            if ($(".InAuthPage").is(":visible")) {
                var PI = UmPatient_AuthInfo("", "");
                var btnAccId = "#AuthDiv_" + PI.AuthNoId;
                switch (authEligibilityType) {
                    case 1:
                        updateAuthEligibilityDetails(patientId, authId, authNo, lobBenId, memBenfPlanId);
                        break;
                    case 2:
                        $("#divReconcileEligibilityMessage", btnAccId).hide();
                        $("#divReconcileEligibilityWarningMessage", btnAccId).hide();
                        $("#divReconcileEligibilityErrorMessage", btnAccId).show();
                        scrollUpUmAGScreens();
                        break;
                    case 3:
                        $("#divReconcileEligibilityMessage", btnAccId).hide();
                        $("#divReconcileEligibilityErrorMessage", btnAccId).hide();
                        $("#divReconcileEligibilityWarningMessage", btnAccId).show();
                        scrollUpUmAGScreens();
                        break;
                    default:
                        break;
                }
            }
            else {
                switch (authEligibilityType) {
                    case 1:
                        $('#popUpDialog1 #divAuthReconcileEligibilityErrorMessage').hide();
                        $('#popUpDialog1 #divAuthReconcileEligibilityWarningMessage').hide();
                        $('#popUpDialog1 #divERExistMessage').hide();
                        bindMemberEligibility(patientId, authId, authNo, "", 0, lobBenId, memBenfPlanId, sectionName);
                        break;
                    case 2:
                        $('#popUpDialog1 #divAuthReconcileEligibilityWarningMessage').hide();
                        $('#popUpDialog1 #divAuthReconcileEligibilityErrorMessage').show();
                        popUpScrollTop();
                        break;
                    case 3:
                        $('#popUpDialog1 #divAuthReconcileEligibilityErrorMessage').hide();
                        $('#popUpDialog1 #divAuthReconcileEligibilityWarningMessage').show();
                        popUpScrollTop();
                        break;
                    default:
                        break;
                }
            }
        },
        error: function () {
            loader(0);
            CustomAlert("Error Occurred.");
        }
    });
}
function updateAuthEligibilityDetails(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName, callback) {
    loader(1);
    var PI = UmPatient_AuthInfo("", "");
    var authDivId = PI.AuthDivId;
    var btnAccId = "#AuthDiv_" + PI.AuthNoId;
    var requestObj = {
        AuthNo: authNo,
        LobBenID: lobBenId,
        MemBenfPlanID: memBenfPlanId,
        UpdatedBy: memberidval
    };
    $.ajax({
        type: "POST",
        url: baseURL + "/Authorization/UpdateAuthEligibilityReconciliationDetails",
        data: requestObj,
        success: function (data) {
            loader(0);
            if (data.success && data.msg.indexOf("Authorization") !== -1 && $(".InAuthPage").is(":visible")) {
                var AccId = authDivId + " #Accordion_Group_2 #AuthInit_2_1";
                var AccordId = AccId.substring(1, AccId.length);
                var authPatientEligibility = AccordId + " #Grid_EligibilityReconciliation";
                LoadMemberEligibilityFullView(authPatientEligibility, '', memberidval, '', '', 'none', lobBenId, memBenfPlanId, patientId, lobBenId, memBenfPlanId, false, function () {
                    $(AccId + " .ReconcileEligibilityButtons").hide();
                    $(AccId + " #Grid_EligibilityReconciliation .memberEligibility").prop('disabled', true);
                    $(AccId + " #divStatusActiveInactive").hide();
                    $("#divReconcileEligibilityMessage", btnAccId).show();
                    $("#divReconcileEligibilityWarningMessage", btnAccId).hide();
                    $("#divReconcileEligibilityErrorMessage", btnAccId).hide();
                    if ($(AccId).find('.statusSelectNew').is(':visible')) {
                        $(AccId + " #reconcileEligibility").hide();
                        $(AccId + " #reconcileEligibility").text(' Reconcile eligibility');
                        $(AccId + " #spnReconcileEligibility").hide();
                    }
                    $('#HdnIsOrphanAuth', PI.AuthTabId).val("false");
                    scrollUpUmAGScreens();
                }, false);
            }
            else if (data.success && data.msg.indexOf("Authorization") !== -1 && (sectionName === 'OPEN_AUTHORIZATIONS' || sectionName === 'OPEN_AUTHORIZATIONS_MAL' || sectionName === 'ER_AUTHORIZATIONS')) {
                if (callback && typeof (callback) == "function") {
                    callback(true);
                }
            }
            else if (data.success && data.msg === "True" && $(".InAuthPage").is(":visible")) {
                $("#divReconcileEligibilityExistMessage", btnAccId).show();
            }
            else if (data.success && data.msg === "True" && (sectionName === 'OPEN_AUTHORIZATIONS' || sectionName === 'OPEN_AUTHORIZATIONS_MAL' || sectionName === 'ER_AUTHORIZATIONS')) {
                $('#popUpDialog1 #divERExistMessage').show();
                refreshGridViewforER(authId, 0, sectionName, true);
            }
            else {
                CustomAlert("Error while updating the eligibility.");
            }
        },
        error: function () {
            loader(0);
            CustomAlert("Error while updating the eligibility.");
        }
    });
}

function cancelReconcileEligibility() {
    if ($(".InAuthPage").is(":visible")) {
        var PI = UmPatient_AuthInfo("", "");
        var btnAccId = "#AuthDiv_" + PI.AuthNoId;
        var AccId = PI.AuthDivId + " #Accordion_Group_2 #AuthInit_2_1";
        $(".divReconcileEligibilityMessage", btnAccId).hide();
        $(AccId + " #reconcileEligibility").text(' Reconcile eligibility');
        $(AccId + " #spnReconcileEligibility").hide();
        Auth_AccExpandCollapse('2', '1');
    }
    else if ($(".InComplaintPage").is(":visible")) {
        var CI = AgData.complaintInfo();
        var complaintDivId = CI.complaintDivId;
        $(".clsComplaintReconcileEligibility", complaintDivId).hide();
        $(complaintDivId + " #reconcileComplaintEligibility").text(' Reconcile eligibility');
        $(complaintDivId + " #spnReconcileComplaintEligibility").hide();
        AgLoad.accColAll();
        scrollUpUmAGScreens();
        reconcileEligibility();
    }
    else {
        onERPopUpClose();
    }
}
function reconcileEligibilityAndNavToAuth(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName) {
    updateAuthEligibilityDetails(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName, function () {
        onERPopUpClose();
        refreshGridViewforER(authId, 0, sectionName, false);
        ClickFireAuthId(authId, patientId);
    }
    );
}
function closePopupLeanOverlay() {
    if ($('#lean_overlay_0').is(":visible")) {
        $('#lean_overlay_0').hide();
    }
}
function returnToEligibilityReconciliation(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName) {
    updateAuthEligibilityDetails(patientId, authId, authNo, lobBenId, memBenfPlanId, sectionName, function () {
        onERPopUpClose();
        refreshGridViewforER(authId, 0, sectionName, false);
    });
}
function validateComplaintEligibilityPrerequisites(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName) {
    loader(1);
    $.ajax({
        type: "GET",
        url: baseURL + "/Complaint/ValidateEligibilityForComplaint?complaintId=" + complaintId + "&lobBenId=" + lobBenId,
        dataType: "json",
        success: function (ComplaintEligibilityResponse) {
            loader(0);
            if ($(".InComplaintPage").is(":visible")) {
                var CI = AgData.complaintInfo();
                var complaintDivId = CI.complaintDivId;
                switch (ComplaintEligibilityResponse) {
                    case 1:
                        updateComplaintEligibilityDetails(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId);
                        break;
                    case 2:
                        $(complaintDivId + ' #responseERStatus').show();
                        $(complaintDivId + " #responseERStatus").MessageBox({
                            Message: "Selected eligibility does not have the required configuration for Complaint Type, Complaint Class and/or Complaint Category.",
                            Type: "Error",
                            IsSliding: true,
                            NoBtnName: null,
                            yesCallback: null,
                            noCallback: null
                        });
                        break;
                    case 3:
                        $(complaintDivId + ' #responseERStatus').show();
                        $(complaintDivId + " #responseERStatus").MessageBox({
                            Message: "The selected eligibility does not have the required configuration for TAT mappings.",
                            Type: "Error",
                            IsSliding: true,
                            NoBtnName: null,
                            yesCallback: null,
                            noCallback: null
                        });
                        break;
                    default:
                        break;
                }
            }
            else {
                switch (ComplaintEligibilityResponse) {
                    case 1:
                        $('#popUpDialog1 #divComplaintTATMessage').hide();
                        $('#popUpDialog1 #divComplaintConfigMessage').hide();
                        $('#popUpDialog1 #divERExistMessage').hide();
                        bindMemberEligibility(patientId, "", 0, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName);
                        break;
                    case 2:
                        $('#popUpDialog1 #divComplaintTATMessage').hide();
                        $('#popUpDialog1 #divComplaintConfigMessage').show();
                        popUpScrollTop();
                        break;
                    case 3:
                        $('#popUpDialog1 #divComplaintConfigMessage').hide();
                        $('#popUpDialog1 #divComplaintTATMessage').show();
                        popUpScrollTop();
                        break;
                    default:
                        break;
                }
            }
        },
        error: function () {
            loader(0);
            CustomAlert("Error Occurred.");
        }
    });
}
function reconcileEligibilityAndNavToComplaint(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName) {
    updateComplaintEligibilityDetails(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName, function () {
        onERPopUpClose();
        refreshGridViewforER(0, complaintId, sectionName, false);
        ClickFireComplaintId(complaintNo, patientId);
    }
    );
}
function updateComplaintEligibilityDetails(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName, callback) {
    loader(1);
    var CI = AgData.complaintInfo();
    var complaintDivId = CI.complaintDivId;
    var complaintTabId = CI.complaintTabId;
    var requestObj = {
        ComplaintRecordID: complaintNo,
        LobBenID: lobBenId,
        MemBenfPlanID: memBenfPlanId,
        UpdatedBy: memberidval,
        PatientId: patientId
    };
    $.ajax({
        type: "POST",
        url: baseURL + "/Complaint/UpdateComplaintEligibilityReconciliationDetails",
        data: requestObj,
        success: function (data) {
            loader(0);
            if (data.success && data.msg.indexOf("ComplaintRecordID") !== -1 && $(".InComplaintPage").is(":visible")) {
                $(complaintDivId + " .ReconcileEligibilityButtons").hide();
                $(complaintDivId + " #Grid_EligibilityReconciliation .memberEligibility").prop('disabled', true);
                $(complaintDivId + " #divStatusActiveInactive").hide();
                $("#divcomplaintEligibilitySuccessMessage", complaintDivId).show();
                $(complaintTabId + ' #HdnIsOrphanComplaint').val('false');
                if ($(complaintDivId).find('.statusSelectNew').is(':visible')) {
                    $(complaintDivId + " #divComplaintERButton").hide();
                    $(complaintDivId + " #reconcileComplaintEligibility").hide();
                    $(complaintDivId + " #reconcileComplaintEligibility").text(' Reconcile eligibility');
                    $(complaintDivId + " #spnReconcileComplaintEligibility").hide();
                }
                $('#divComplaint_EligibilityDetail', complaintDivId).load(baseURL + '/AppealGrievance/EligibilityDetail');
            }
            else if (data.success && data.msg.indexOf("ComplaintRecordID") !== -1 && (sectionName === 'OPEN_COMPLAINTS' || sectionName === 'OPEN_COMPLAINTS_MAL' || sectionName === 'ER_COMPLAINTS')) {
                if (callback && typeof (callback) == "function") {
                    callback(true);
                }
            }
            else if (data.success && data.msg === "True" && $(".InComplaintPage").is(":visible")) {
                $(complaintDivId + ' #responseERStatus').show();
                $(complaintDivId + " #responseERStatus").MessageBox({
                    Message: "Eligibility has been attached to the record. No reconciliation required.",
                    Type: "Warning",
                    IsSliding: true,
                    NoBtnName: null,
                    yesCallback: null,
                    noCallback: null
                });
            }
            else if (data.success && data.msg === "True" && (sectionName === 'OPEN_COMPLAINTS' || sectionName === 'OPEN_COMPLAINTS_MAL' || sectionName === 'ER_COMPLAINTS')) {
                $('#popUpDialog1 #divERExistMessage').show();
                refreshGridViewforER(0, complaintId, sectionName, true);
            }
            else {
                CustomAlert("Error while updating the eligibility.");
            }
        },
        error: function () {
            loader(0);
            CustomAlert("Error while updating the eligibility.");
        }
    });
}
function returnToHomePage(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName) {
    updateComplaintEligibilityDetails(patientId, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName, function () {
        onERPopUpClose();
        refreshGridViewforER(0, complaintId, sectionName, false);
    });
}
function gridRefreshforER(gridId) {
    if ($("#" + gridId).data("kendoGrid") != null) {
        $("#" + gridId).data("kendoGrid").dataSource.read();
    }
    else {
        //No logic
    }
}
function refreshGridViewforER(authId, complaintId, sectionName, isMsgVisible) {
    switch (sectionName.toUpperCase()) {
        case 'OPEN_AUTHORIZATIONS':
            gridRefreshforER("OpenAuthorization");
            break;
        case 'OPEN_COMPLAINTS':
            gridRefreshforER("OpenComplaints");
            break;
        case 'OPEN_AUTHORIZATIONS_MAL':
            gridRefreshforER("OpenAuthorizationMAL");
            break;
        case 'OPEN_COMPLAINTS_MAL':
            gridRefreshforER("OpenComplaintsMAL");
            break;
        case 'ER_AUTHORIZATIONS':
            gridRefreshforER("EligibilityReconAuthGrid");
            if (!isMsgVisible) {
                $("#divReconcileEligibilitySuccessMessage").show();
                $("#lblReconcileEligibilitySuccessMessage").text('Authorization ' + authId + ' eligibility is updated.');
            }
            break;
        case 'ER_COMPLAINTS':
            gridRefreshforER("EligibilityReconComplaintGrid");
            if (!isMsgVisible) {
                $("#divReconcileEligibilitySuccessMessage").show();
                $("#lblReconcileEligibilitySuccessMessage").text('Complaint ' + complaintId + ' eligibility is updated.');
            }
            break;
        default:
            break;
    }
}
function bindMemberEligibility(patientId, authId, authNo, complaintId, complaintNo, lobBenId, memBenfPlanId, sectionName) {
    var patientEligibility = "Grid_EligibilityReconciliation";
    LoadMemberEligibilityFullView(patientEligibility, '', memberidval, '', '', 'none', lobBenId, memBenfPlanId, patientId, lobBenId, memBenfPlanId, false, function () {
        $('#popUpDialog1 #reconcile_update_btn').hide();
        $("#popUpDialog1 #Grid_EligibilityReconciliation .memberEligibility").prop('disabled', true);
        $("#popUpDialog1 #Grid_EligibilityReconciliation #MemEligMainView #divStatusActiveInactive").hide();
        $('#popUpDialog1 #divReconcileEligibilityInfoMessage').hide();
        if (complaintNo > 0) {
            $('#popUpDialog1 #divReconcileEligibilityComplaintNavMessage').show();
            $('#popUpDialog1 #lblComReconcileEligibilityNavMessage').show();
            $('#popUpDialog1 #ancNavToComplaint').attr('onclick', 'reconcileEligibilityAndNavToComplaint("' + patientId + '", "' + complaintId + '", "' + complaintNo + '", "' + lobBenId + '", "' + memBenfPlanId + '", "' + sectionName + '")');
            $('#popUpDialog1 #ancNavToHome').attr('onclick', 'returnToHomePage("' + patientId + '", "' + complaintId + '", "' + complaintNo + '", "' + lobBenId + '", "' + memBenfPlanId + '", "' + sectionName + '")');
        }
        else {
            $('#popUpDialog1 #divReconcileEligibilityAuthNavMessage').show();
            $('#popUpDialog1 #lblReconcileEligibilitynavMessage').show();
            $('#popUpDialog1 #ancNavToAuthorization').attr('onclick', 'reconcileEligibilityAndNavToAuth("' + patientId + '", "' + authId + '", "' + authNo + '", "' + lobBenId + '", "' + memBenfPlanId + '", "' + sectionName + '")');
            $('#popUpDialog1 #ancNavToHome').attr('onclick', 'returnToEligibilityReconciliation("' + patientId + '", "' + authId + '", "' + authNo + '", "' + lobBenId + '", "' + memBenfPlanId + '", "' + sectionName + '")');
        }
    }, false);
}
function popUpScrollTop() {
    $("#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
}
function scrollUpUmAGScreens() {
    $("html, body").animate({ scrollTop: 0 }, 'slow');
}
function showReconcileTextExpColl(complaintDivId) {
    $(complaintDivId + " #reconcileComplaintEligibility").text(' Reconciling eligibility');
    $(complaintDivId + " #spnReconcileComplaintEligibility").show();
    $(complaintDivId + " #spnReconcileComplaintEligibility").text(' - Record of eligibilities available for this member' + "'s " + 'complaint.');
}
